import { useMemo, useCallback } from 'react'
import { useRouter } from 'next/router'

import { stringifyUrl } from '@ucheba/utils/helpers/router'

import { divisionsSelector } from '@ucheba/store/institutions/divisions'
import { useSelector } from 'react-redux'

import { FACETS_NAMES } from '@ucheba/store/institutions/divisions/constants'

import { TUseDivisionsNavigation } from '../types'

// Создаем список назаний и ссылок для кнопок навигации - items
// Вычисляем номер активного элемента навигации - activeIndex

export const useDivisionsNavigation: TUseDivisionsNavigation = () => {
  const { query, push, asPath } = useRouter()

  const facets = useSelector(divisionsSelector.facets)

  const items = useMemo(
    () =>
      facets?.map(({ name, value }) => {
        return {
          slug: FACETS_NAMES[value],
          name,
        }
      }),
    [facets]
  )

  const onClick = useCallback(
    (_, slug: string) => {
      push(
        stringifyUrl(asPath, {
          set: {
            type: slug,
          },
        }),
        undefined,
        { shallow: true }
      )
    },
    [asPath, push]
  )

  const activeIndex = useMemo(() => {
    const currentType = query.type

    return currentType
      ? facets?.findIndex(({ value }) => FACETS_NAMES[value] === currentType)
      : 0
  }, [facets, query.type])

  return {
    items,
    activeIndex,
    onClick,
  }
}
